// ── FACTION CONFIG (centralized) ──
// Game mechanics config
const FACTION_CFG={
  prism:{
    color:'#00ddff', accent:'#aaffff', workerColor:'#88ccff',
    warriorColor:'#ffffff', buildingName:'TEMPLE',
    workerLabel:'ACOLYTE', warriorLabel:'WITCH',
    workerCost:5,
    buildingColor:'#c0e8ff',
    barracksName:'PORTAL', barracksLabel:'PORTAL',
    warriorCost:10, warriorDesc:'Ranged — magic projectiles',
    warrior2Label:'LEGIONNAIRES', warrior2Desc:'Mixed sword and bow squad, trained four at a time',
    warrior2Cost:34, warrior2Icon:'🗡', warrior2Fn:'makeLegionnaireSquad', warrior2Count:4,
    councilOfLightName:'COUNCIL OF LIGHT', councilOfLightLabel:'COUNCIL OF LIGHT',
    councilOfLightDesc:'Unlocks LEGIONNAIRE production at the PORTAL', councilOfLightIcon:'💠',
    structName:'SHRINE', structLabel:'SHRINE',
    prismLabel:'PRISM', prismDesc:'Unique royal summoner — conjures Legionnaires while engaging enemies (limit 1)',
    prismCost:200, prismOilCost:75, prismIcon:'💎',
    arkshipLabel:'ARKSHIP', arkshipDesc:'Unique royal flagship — requires an existing Prism, who is drawn inside; phase into a squat cone to deploy her with 5 Witches, or unfurl blade-fins and attack with twin beams (limit 1)',
    arkshipCost:150, arkshipOilCost:60, arkshipIcon:'💫',
    eliteLabel:'ORACLE', eliteDesc:'Ranged — high damage prismatic bolts',
    eliteCost:30, eliteIcon:'🔮', eliteOilCost:20,
    elite2Label:'WIZARD', elite2Desc:'Ranged — chain lightning bounces between enemies',
    elite2Cost:18, elite2Icon:'⚡', elite2Fn:'makeWizard', elite2OilCost:25,
    // UI icons
    workerIcon:'🧙', warriorIcon:'✨',
    barracksIcon:'🌀', structIcon:'🏛', baseIcon:'🏰',
    cannonColor:'#00f5ff', cannonSound:'rtsPrismCannon',
    aerialName:'WARP CONDUIT', aerialLabel:'WARP CONDUIT', aerialIcon:'🌀',
    aerialUnitLabel:'WAR DRONE', aerialUnitDesc:'Aerial — fast energy bolts, immune to melee',
    aerialUnitCost:22, aerialUnitIcon:'✦', aerialFn:'makeStarFighter', aerialOilCost:8,
    aerial2Label:'LIGHT FIGHTER', aerial2Desc:'Aerial — fires a piercing beam of light',
    aerial2Cost:28, aerial2Icon:'☀', aerial2Fn:'makeLightFighter', aerial2OilCost:14,
    oilRigName:'ALTAR', oilRigLabel:'ALTAR', oilRigIcon:'⛩',
    oilResourceName:'LIGHT', oilResourceIcon:'🌟',
  },
  shadow:{
    color:'#9922ff', accent:'#dd88ff', workerColor:'#8855cc',
    warriorColor:'#cc88ff', buildingName:'TEMPLE',
    workerLabel:'SHADE', warriorLabel:'SWORDSMAN',
    workerCost:5,
    buildingColor:'#1a0030',
    barracksName:'TRAINING FIELD', barracksLabel:'TRAINING FIELD',
    warriorCost:10, warriorDesc:'Melee — fast sword charge',
    structName:'DARK SHRINE', structLabel:'DARK SHRINE',
    eliteLabel:'DARK WARRIOR', eliteDesc:'Ranged — black magic bolts that chain',
    eliteCost:20, eliteIcon:'🌑', eliteOilCost:25,
    elite2Label:'NECROMANCER', elite2Desc:'Raises dead Swordsmen — fast revive, strong damage',
    elite2Cost:15, elite2Icon:'💀', elite2Fn:'makeNecromancer', elite2OilCost:20,
    // UI icons
    workerIcon:'🥷', warriorIcon:'⚔',
    barracksIcon:'⚔', structIcon:'⚡', baseIcon:'🏰',
    cannonColor:'#cc44ff', cannonSound:'rtsShadowCannon',
    aerialName:'WARP CONDUIT', aerialLabel:'WARP CONDUIT', aerialIcon:'🌀',
    aerialUnitLabel:'WAR DRONE', aerialUnitDesc:'Aerial — fast energy bolts, immune to melee',
    aerialUnitCost:22, aerialUnitIcon:'✦', aerialFn:'makeStarFighter', aerialOilCost:8,
    aerial2Label:'DESTROYER', aerial2Desc:'Aerial — hurls slow orbs of darkness that damage an area',
    aerial2Cost:34, aerial2Icon:'🌌', aerial2Fn:'makeDestroyer', aerial2OilCost:18,
    darkShipGoldCost:80, darkShipOilCost:40,
    darkShipLabel:"DARK WARRIOR'S SHIP", darkShipIcon:'🛸',
    darkShipDesc:"Carries Vanthel, a legendary dark warrior. Hurls void orbs stronger than the Destroyer's, and can't release Vanthel while it has enemies in sight",
    vanthelLabel:'VANTHEL', vanthelIcon:'👹',
    councilOfDarknessName:'COUNCIL OF DARKNESS', councilOfDarknessLabel:'COUNCIL OF DARKNESS',
    councilOfDarknessDesc:'Unlocks NECROMANCER production at the DARK SHRINE and DESTROYER production at the WARP CONDUIT',
    councilOfDarknessIcon:'🕯',
    oilRigName:'GARDEN', oilRigLabel:'GARDEN', oilRigIcon:'🌺',
    oilResourceName:'ESSENCE', oilResourceIcon:'💜',
  },
  roboto:{
    color:'#ff8800', accent:'#ffcc44', workerColor:'#aa6622',
    warriorColor:'#ff9933', buildingName:'FACTORY',
    workerLabel:'DRONE', warriorLabel:'GUNBOT',
    workerCost:5,
    buildingColor:'#2a2010',
    barracksName:'BARRACKS', barracksLabel:'BARRACKS',
    warriorCost:6, warriorDesc:'Ranged — rapid fire gun',
    warrior2Label:'WARBOT', warrior2Desc:'Ranged — heavier armor, harder-hitting rifle than GunBot',
    warrior2Cost:14, warrior2Icon:'🦿', warrior2Fn:'makeWarbot',
    researchLabName:'RESEARCH LAB', researchLabLabel:'RESEARCH LAB',
    researchLabDesc:'Research military tech to unlock WARBOT, TANK, and WARSHIP production', researchLabIcon:'🔬',
    researchLabel:'MILITARY TECH', researchDesc:'Unlocks WARBOT, TANK, and WARSHIP production', researchCost:100,
    gonguiLabel:'GONGUI', gonguiDesc:'Unique Roboto King — human commander wielding twin gauntlet-cannons, can board a Capital Ship (limit 1)',
    gonguiCost:80, gonguiOilCost:35, gonguiIcon:'👑',
    structName:'ARMORY', structLabel:'ARMORY',
    eliteLabel:'SHOCKBOT', eliteDesc:'Ranged — chain lightning hits multiple enemies',
    eliteCost:24, eliteIcon:'⚡',
    elite2Label:'TANK', elite2Desc:'Heavy armored unit — high HP, AOE cannon',
    elite2Cost:25, elite2Icon:'🚗', elite2Fn:'makeTank', tankOilCost:12,
    // UI icons
    workerIcon:'🤖', warriorIcon:'🦾',
    barracksIcon:'🪖', structIcon:'🏭', baseIcon:'🏗',
    cannonColor:'#ffaa00', cannonSound:'rtsCannonFire',
    aerialName:'SHIPYARD', aerialLabel:'SHIPYARD', aerialIcon:'🚀',
    aerialUnitLabel:'WAR DRONE', aerialUnitDesc:'Aerial — heavy missiles, immune to melee',
    aerialUnitCost:22, aerialUnitIcon:'🚀', aerialFn:'makeSkyAttacker', aerialOilCost:8,
    aerial2Label:'WARSHIP', aerial2Desc:'Aerial — switches between single-target and multi-target fire',
    aerial2Cost:60, aerial2Icon:'🚀', aerial2Fn:'makeWarship', aerial2OilCost:30,
    capitalShipLabel:'CAPITAL SHIP', capitalShipDesc:'Unique flagship — while airborne, fires one bullet at every enemy it faces; land it to deploy GONGUI (limit 1)',
    capitalShipCost:120, capitalShipIcon:'🛸', capitalShipOilCost:50,
    oilRigName:'OIL RIG', oilRigLabel:'OIL RIG', oilRigIcon:'🛢',
  },
};

// UI/presentation config (reveal screen, card select)
const FACTION_DATA={
  shadow:{ armada:'SHADOW ARMADA', champion:'THE SWORDSMAN', lore:'"From the void between stars, he emerged. None who faced his blade lived to name him."', accentColor:'#9933ff', progression:{},
    desc:'Masters of dark steel and silent death. The swordsman strikes before you see him.',
    statBars:[{label:'ATK',val:90},{label:'DEF',val:75},{label:'SPD',val:95}] },
  prism: { armada:'PRISM ARMADA',  champion:'THE WHITE WITCH', lore:'"She speaks in light. Her words become spells. Her spells become storms."', accentColor:'#00ddff', progression:{},
    desc:'Wielders of radiant light. The White Witch bends reality with spectral sorcery.',
    statBars:[{label:'ATK',val:80},{label:'DEF',val:60},{label:'MGC',val:100}] },
  roboto:{ armada:'ROBOTO ARMADA', champion:'THE GUNBOT',     lore:'"Forged in a dead star\'s core. Programmed for one purpose: total suppression."', accentColor:'#ff8800', progression:{},
    desc:'Iron-clad war machines. The Gunbot never misses, never tires, never stops.',
    statBars:[{label:'ATK',val:85},{label:'DEF',val:95},{label:'RNG',val:88}] },
};

// Renders the ATK/DEF/SPD-style stat bars used on the faction select cards —
// reused anywhere a faction's stats need to show (reveal screen, in-game HUD).
function factionStatBarsHTML(faction){
  const fd=FACTION_DATA[faction];
  if(!fd || !fd.statBars) return '';
  const color=(FACTION_CFG[faction]||{}).color || fd.accentColor;
  return fd.statBars.map(s=>
    `<div class="fc-stat"><span class="fc-stat-label">${s.label}</span><div class="fc-bar"><div class="fc-fill" style="width:${s.val}%;background:${color}"></div></div></div>`
  ).join('');
}

// Populates the in-game HUD's faction badge/champion/stat bars for whichever
// faction the local player is playing (singleplayer, training, and MP host/guest).
function updateGameFactionPanel(faction){
  const cfg=FACTION_CFG[faction], fd=FACTION_DATA[faction];
  if(!cfg || !fd) return;
  const badge=document.getElementById('rts-faction-badge');
  if(badge){ badge.textContent=faction.toUpperCase()+' ARMADA'; badge.style.color=cfg.color; }
  const champ=document.getElementById('rts-faction-champion');
  if(champ) champ.textContent=fd.champion;
  const stats=document.getElementById('rts-faction-stats');
  if(stats) stats.innerHTML=factionStatBarsHTML(faction);
}

// Shared DSO state
let dsoSelectedFaction = null;
let dsoRevealRAF = null;
let dsoRevealFrame = 0;
let dsoPreviewRAF = null;

//# sourceMappingURL=factions.js.map
